import { useState } from 'react';
import {
  saveTooltipPreference,
  useTooltipPreferenceError,
  useTooltipPreferenceReady,
  useTooltipsEnabled,
} from './tooltip-preference';

// standards: allow function-length because CapturePoint port, split tracked in docs/engineering/workbench-port.md
export function TooltipSettings() {
  const enabled = useTooltipsEnabled();
  const ready = useTooltipPreferenceReady();
  const readFailed = useTooltipPreferenceError();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const change = async (value: boolean) => {
    if (saving) return;
    setSaving(true);
    setError('');
    try {
      await saveTooltipPreference(value);
    } catch {
      setError('Your tooltip preference could not be saved. Please try again.');
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="tooltip-settings">
      <label className="tooltip-settings-control">
        <input
          type="checkbox"
          role="switch"
          data-telemetry="tooltips-toggle"
          checked={enabled}
          disabled={!ready || saving}
          onChange={(event) => void change(event.target.checked)}
        />
        <span className="interface-size-setting-copy">
          <strong>Show tooltips</strong>
          <small>Show a short label when you point at a button.</small>
        </span>
      </label>
      {!ready && (
        <p className="appearance-error" role="status">
          {readFailed
            ? 'Tooltip preferences could not be read. Reopen the app to try again.'
            : 'Reading tooltip preference…'}
        </p>
      )}
      {error && (
        <p className="appearance-error" role="alert" data-telemetry="error:appearance-save-failed">
          {error}
        </p>
      )}
    </div>
  );
}
